import { assert } from './logger.js';

// User session.
class Session {
  get id() {
    return this.#id;
  }

  set id(id) {
    this.#id = id;
  }

  get userid() {
    return this.#user && this.#user.id;
  }

  get user() {
    return this.#user;
  }

  set user(v) {
    if (v) {
      assert(v.id, `[session] no user id`);
      assert(v.name, `[session] no user name`);
      assert(v.email, `[session] no user email`);
    }

    this.#user = v;
    this.#hooks.forEach(hook => hook(this.#user));
  }

  // Adds a callback that will be called once on a user change (login/out.)
  hookOnChange(hook) {
    this.#hooks.push(hook);
  }

  #id;
  #user;
  #hooks = [];
}

export const session = new Session();
